<template>
	<div v-if="rundown"
			class="rundown d-flex align-items-center"
			:class="[ `type-${type}`, { 'play-live': isPlayingLive }, { 'play-preview': ActivePreview()}, {'bg-disabled': isLocked}, {'disabled-item': isDisabled} ]"
			:style="{backgroundColor: isSeparator && content && content.SeparatorBGColor ? content.SeparatorBGColor:'',
			color: isSeparator && content && content.SeparatorFontColor ? content.SeparatorFontColor:''}"
			@click="setSelected">
		<!-- <div class="context-area-rundown-item">
		</div> -->
		<div class="absolute indicator-preview" v-if="isPlayingPreview && !isSeparator">
		</div>
		<div
			class="rundown-progress"
			:style="{ width: progress, zIndex:0 }"
			v-if="isPlayingLive && hasProgress && !isSeparator">
		</div>
		<!-- Toggle Play -->
		<button
			:class="{'disabled': isFadeOutingLive}"
			:disabled="userCollaborators === 'event_manager' "
			type="button"
			class="btn btn-default btn-icon toggle p-0 "
			@click="delayPlay('live')"
			v-if="!isLocked && !isSeparator">
			<i class="material-icons text-success pt-1-5px" v-if="!this.rundown.show_is_playing_live">play_arrow</i>
			<i class="material-icons text-danger pt-1px " v-if="this.rundown.show_is_playing_live">stop</i>
			<!-- <div v-if="isDelayPlay" class="is-loading delay-play-loading"></div> -->
		</button>
		<!-- Locked -->
		<button
			type="button"
			class="btn btn-default btn-icon toggle p-0"
			v-tooltip="$t('Item Locked')"
			v-if="isLocked && !isSeparator">
			<i class="material-icons text-warning">lock</i>
		</button>
		<!-- Name -->
		<div class="context-area-rundown-item" v-if="!isSeparator" v-click-outside="hideContextMacro" @contextmenu="toggleContextMacro()" ref="dropdownContextRundown" @click="clickItem">
			<div
				:class="{'disabled': isFadeOutingPreview}"
				@click="togglePlay('preview')"
				class="text-small rundown-name ellipsis-text">
				{{ rundown ? rundown.name : '-' }}
			</div>
		</div>
		<!-- only active when type is separator -->
		<div class="context-area-rundown-item"  v-if="isSeparator" v-click-outside="hideContextMacro" @contextmenu="toggleContextMacro()" ref="dropdownContextRundown" @click="clickItem">
			<div
				@click.stop="togglePlay('preview')"
				class="rundown-separator text-small ellipsis-text">
				{{ rundown ? rundown.name : '-' }}
			</div>
		</div>
		<!-- Time -->
		<div v-if="hideTimer.includes(type)" class="rundown-time ml-a absolute" :class="{'text-bright': isPlayingLive}"></div>
		<div v-else-if="type === 'timer'" @contextmenu="toggleContextMacro()" class="rundown-time absolute z-index-1" :class="{'text-bright': isPlayingLive}">{{rundown && time ? timerDuration : '00:00'}}</div>
		<div v-else-if="type === 'video' || type === 'audio' " @contextmenu="toggleContextMacro()" class="rundown-time absolute z-index-1" :class="{'text-bright': isPlayingLive}">{{rundown ? mediaDuration : 0}}</div>
		<div v-else @contextmenu="toggleContextMacro()" class="rundown-time absolute z-index-1" :class="{'text-bright': isPlayingLive}">{{ rundown && duration ? LowerThirdDuration : ''  }}</div>
		<!-- Icon -->
		<component
			class="rundown-icon"
			:class="`type-${type}`"
			:is="icon"
			:size="16"
			:title="iconLabel"
			v-if="!isSeparator"
			v-tooltip="iconLabel"
		/>
		<!-- Layer Index -->
		<div v-if="!isSeparator" class="rundown-layer-index mr-4 mw-20px">{{ rundown.layer_index || 0 }}</div>
		<!-- Settings -->
		<!-- button DnD disabled -->
		<button
			v-if="!smallScreen"
			type="button"
			class="drag-items-icon btn btn-plain btn-icon p-0 b-0  item-handler z-index-100"
			:class="{'rundown-actions':!isSeparator, 'rundown-actions-separator':isSeparator}">
			<img src="/img/hamburger-menu.png" width="8" alt="Grafias">
		</button>
		<!-- button DnD visible -->
		<!-- <button
			v-if="!smallScreen && isPlayingMacroListDone && !visibleElements"
			type="button"
			class="drag-items-icon btn btn-plain btn-icon p-0 b-0  item-handler z-index-100 "
			:class="{'rundown-actions':!isSeparator, 'rundown-actions-separator':isSeparator}">
			<img src="/img/hamburger-menu.png" width="8" alt="Grafias">
		</button> -->
		<!-- context -->
		<ul v-if="opened && closeContextItem" class="pointer dropdown-context-rundown-item"
			:class="{'dropdown-context-rundown-item-scroll': scrollVisible}"
			id="contextItemRundown">
			<li>
				<button class="text-white-context pb-2 pt-5px btn btn-item-rundown-item"
				:disabled="isLocked" @click="takeIn"
				>{{ isPlayingLive ? $t('Take Out') : $t('Take In')  }}</button>
			</li>
			<li @mouseover="closeContext">
				<button class="text-white-context pb-2 pt-5px btn btn-item-rundown-item"
				:disabled="isLocked" @click="forcePlay"
				>{{ $t('Force Play')  }}</button>
			</li>
			<!--  access rundown item -->
			<li @mouseover="openContextAccess">
				<button
					@mouseover="openContextAccess"
					disabled
					onclick="return false;"
					type="button"
					class="flex-center btn-item-context pl-4 pb-2 pt-2"
					>
					<span class="text-left" style="width:100px;">{{ $t('Access') }}</span>
					<i class="material-icons text-white md-18 ml-auto">keyboard_arrow_right</i>
				</button>
			</li>
			<!-- <li v-if="type === 'lower_third'" @mouseover="showAccessItem = false">
				<button class="text-white-context pb-2 pt-5px btn btn-item-rundown-item"
				:disabled="isLocked && this.content && this.content.template && this.content.template.file_path"
				@click="renderFrame"
				>{{ $t('Render')  }}</button>
			</li> -->
			<li v-if="type === 'lower_third'" @mouseover="openContextRender">
				<button
					@mouseover="openContextRender"
					disabled
					onclick="return false;"
					type="button"
					class="flex-center btn-item-context pl-4 pb-2 pt-2"
					>
					<span class="text-left" style="width:100px;">{{ $t('Render') }}</span>
					<i class="material-icons text-white md-18 ml-auto">keyboard_arrow_right</i>
				</button>
			</li>
			<li @mouseover="closeContext">
				<button class="text-white-context pb-2 pt-5px btn btn-item-rundown-item"
				:disabled="isPlayingLive || isLocked" @click="edit"
				>{{ $t('Edit') }}</button>
			</li>
			<li>
				<button class="text-white-context pb-2 pt-5px btn btn-item-rundown-item"
				:disabled="isLocked" @click="duplicate"
				>{{ $t('Duplicate') }}</button>
			</li>
			<li>
				<button class="text-white-context pb-2 pt-5px btn btn-item-rundown-item"
				:disabled="isLocked" @click="remove"
				>{{ $t('Delete') }}</button>
			</li>
			<li>
				<button @click="toggleLock" class="flex-center w-100 btn-item-context pl-4 pb-2 pt-2">
					<span v-if="!isLocked">{{ $t('Lock') }}</span>
					<span v-if="isLocked">{{ $t('Unlock') }}</span>
					<i class="material-icons text-white md-18 ml-auto" v-if="isLocked">check</i>
				</button>
			</li>
			<li>
				<button :disabled="isPlayingLive || isLocked" @click="toggleShy" class="text-white-context pb-2 pt-5px btn btn-item-rundown-item">
					<span :class="{'disable-item-menu-rundown': isPlayingLive || isLocked, 'ml-0': isShy}">{{ $t('Shy Asset') }}</span>
					<i class="material-icons text-white md-18 ml-auto" v-if="isShy">check</i>
				</button>
			</li>
			<li v-if="type === 'custom_page'">
				<button class="text-white-context pb-2 pt-5px btn btn-item-rundown-item"
				:disabled="isLocked || !isPlayingLive" @click="toggleHide('live')"
				>{{ rundown.is_hidden ? $t('Show') : $t('Hide') }}</button>
			</li>
			<li v-if="type === 'custom_page'">
				<button class="text-white-context pb-2 pt-5px btn btn-item-rundown-item"
				:disabled="isLocked" @click="forceReset()"
				>{{ $t('Force Reset') }}</button>
			</li>
		</ul>
		<!-- access item rundown -->
		<ul @mouseleave="showAccessItem = false" v-if="showAccessItem && !scrollVisible" :class="{'dropdown-context-access-item': !scrollVisible, 'dropdown-context-access-item-scroll': scrollVisible}">
			<li @click="copyURLitem('play')" class="text-white-context pl-4 pb-2 pt-2 pointer">
				{{ $t('Copy play URL') }}
			</li>
			<li @click="copyURLitem('stop')" class="text-white-context pl-4 pb-2 pt-2 pointer">
				<div class="text-white">{{ $t('Copy Stop URL') }}</div>
			</li>
			<li v-if="rundown.type === 'timer'" @click="copyURLitem('pause')" class="text-white-context pl-4 pb-2 pt-2 pointer">
				<div class="text-white">{{ $t('Copy Pause URL') }}</div>
			</li>
			<li v-if="rundown.type === 'timer'" @click="copyURLitem('resume')" class="text-white-context pl-4 pb-2 pt-2 pointer">
				<div class="text-white">{{ $t('Copy Resume URL') }}</div>
			</li>
		</ul>
		<ul @mouseleave="showAccessItem = false" v-if="showAccessItem && scrollVisible" :class="{'dropdown-context-access-item': !scrollVisible, 'dropdown-context-access-item-scroll': scrollVisible}" :style="{ marginTop: (xContext + 50) +'px'}">
			<li @click="copyURLitem('play')" class="text-white-context pl-4 pb-2 pt-2 pointer">
				{{ $t('Copy play URL') }}
			</li>
			<li @click="copyURLitem('stop')" class="text-white-context pl-4 pb-2 pt-2 pointer">
					<div class="text-white">{{ $t('Copy Stop URL') }}</div>
			</li>
			<li v-if="rundown.type === 'timer'" @click="copyURLitem('pause')" class="text-white-context pl-4 pb-2 pt-2 pointer">
				<div class="text-white">{{ $t('Copy Pause URL') }}</div>
			</li>
			<li v-if="rundown.type === 'timer'" @click="copyURLitem('resume')" class="text-white-context pl-4 pb-2 pt-2 pointer">
				<div class="text-white">{{ $t('Copy Resume URL') }}</div>
			</li>
		</ul>
		<!-- render item rundown -->
		<ul @mouseleave="showRenderItem = false" v-if="showRenderItem && !scrollVisible" :class="{'dropdown-context-access-item': !scrollVisible, 'dropdown-context-access-item-scroll': scrollVisible}">
			<li @click="renderFrame('single')" class="text-white-context pl-4 pb-2 pt-2 pointer">
				{{ $t('Single Frame') }}
			</li>
			<li v-if="userRenderSequences" :class="{'disabled-item': isRendering}" @click="renderFrame('multiple')" class="text-white-context pl-4 pb-2 pt-2 pointer">
				<div class="text-white">{{ $t('Sequence') }}</div>
			</li>
		</ul>
		<ul @mouseleave="showRenderItem = false" v-if="showRenderItem && scrollVisible" :class="{'dropdown-context-access-item': !scrollVisible, 'dropdown-context-access-item-scroll': scrollVisible}" :style="{ marginTop: (xContext + 50) +'px'}">
			<li @click="renderFrame('single')" class="text-white-context pl-4 pb-2 pt-2 pointer">
				{{ $t('Single Frame') }}
			</li>
			<li v-if="userRenderSequences" :class="{'disabled-item': isRendering}" @click="renderFrame('multiple')" class="text-white-context pl-4 pb-2 pt-2 pointer">
					<div class="text-white">{{ $t('Sequence') }}</div>
			</li>
		</ul>
		<!-- button more on mobile -->
		<i class="material-icons more-vert pointer" @click.stop="toggleContextOptionMobile()" v-click-outside="hideContextOptionMobile" id="dropdownContextOptionMobile" v-if="smallScreen">more_vert</i>
		<ul v-show="optionMobileOpened" class="pointer dropdown-context-rundown-item-mobile" :class="{'dropdown-context-rundown-item-mobile-scroll': scrollVisible}">
			<!-- Edit -->
			<li v-if="type === 'lower_third'">
				<button class="text-white-context pb-1 pt-5px mt-2 btn btn-item-rundown-item"
				:disabled="isPlayingLive || isLocked" @click="editLtMobile"
				>{{ $t('Edit') }}</button>
			</li>
			<!-- Delete -->
			<li>
				<button class="text-white-context pb-4 pt-4 btn btn-item-rundown-item"
				:disabled="isLocked" @click="remove"
				>{{ $t('Delete') }}</button>
			</li>
			<!-- Lock -->
			<li>
				<button @click="toggleLock" class="flex-center w-100 btn-item-context pl-4 pb-3 pt-2">
					<span v-if="!isLocked">{{ $t('Lock') }}</span>
					<span v-if="isLocked">{{ $t('Unlock') }}</span>
					<i class="material-icons text-whit	e md-18 ml-auto" v-if="isLocked">check</i>
				</button>
			</li>
			<!-- Mute -->
			<li v-if="(type === 'video' || type === 'audio')">
				<button @click="toggleMute" class="flex-center w-100 btn-item-context pl-4 pb-4 pt-2">
					<span v-if="!isMutedMedia">{{ $t('Mute') }}</span>
					<span v-if="isMutedMedia">{{ $t('Unmute') }}</span>
				</button>
			</li>
			<li v-if="(type === 'video_input')">
				<button @click="toggleMute" class="flex-center w-100 btn-item-context pl-4 pb-4 pt-2">
					<span v-if="!isMuted">{{ $t('Mute') }}</span>
					<span v-if="isMuted">{{ $t('Unmute') }}</span>
				</button>
			</li>
		</ul>
		<!-- icon muted -->
		<div class="w-17px" v-if="(type !== 'video' && type !== 'video_input' && type !== '' && type !== 'audio')"></div>
		<!-- composition, video inpuut -->
		<i class="material-icons text-red font15 speaker-off-no-time" v-if="isMuted && (type === 'video_input')">volume_off</i>
		<i class="material-icons text-green font15 speaker-on-no-time" v-if="!isMuted && (type === 'video_input' )">volume_up</i>
		<!-- video media -->
		<i class="material-icons text-red font15 speaker-off" :class="{'speaker-off-no-time': !mediaDuration}" v-if="isMutedMedia && type === 'video'">volume_off</i>
		<i class="material-icons text-green font15 speaker-on" :class="{'speaker-on-no-time': !mediaDuration}" v-if="!isMutedMedia && type === 'video'">volume_up</i>
		<!-- audio -->
		<i class="material-icons text-red font15 speaker-off" :class="{'speaker-off-no-time': !mediaDuration}" v-if="isMutedMedia && type === 'audio'">volume_off</i>
		<i class="material-icons text-green font15 speaker-on" :class="{'speaker-on-no-time': !mediaDuration}" v-if="!isMutedMedia && type === 'audio'">volume_up</i>
	</div>
</template>

<script>
/* eslint-disable no-param-reassign */

import RTC from 'detectrtc';
import ClickOutside from 'vue-click-outside';
import EarthIcon from 'vue-material-design-icons/Earth.vue';
import ImageIcon from 'vue-material-design-icons/Image.vue';
import AlphaAIcon from 'vue-material-design-icons/AlphaA.vue';
import FormatSizeIcon from 'vue-material-design-icons/FormatSize.vue';
import RadioTowerIcon from 'vue-material-design-icons/RadioTower.vue';
import VideoIcon from 'vue-material-design-icons/Video.vue';
import ClockIcon from 'vue-material-design-icons/Clock.vue';
import PictureInPictureIcon from 'vue-material-design-icons/PictureInPictureBottomRightOutline.vue';
import PlayBoxIcon from 'vue-material-design-icons/PlayBox.vue';
import TransitionIcon from 'vue-material-design-icons/Transition.vue';
import FormatTextRotationNoneIcon from 'vue-material-design-icons/FormatTextRotationNone.vue';
import ViewCompactIcon from 'vue-material-design-icons/ViewCompact.vue';
import MovieIcon from 'vue-material-design-icons/Filmstrip.vue';
import WebcamIcon from 'vue-material-design-icons/Webcam.vue';
import CubeIcon from 'vue-material-design-icons/Cube.vue';
import MusicIcon from 'vue-material-design-icons/Music.vue';
import { mapGetters } from 'vuex';

import {
	getRundownItemIcon, toTitleCase, getDuration,
	getAxiosErrorMessage,
	duplicateVar,
	copyToClipboard,
} from '@/lib/helper';
import rundownItemsApi from '@/api/rundownItems';
import templatesApi from '@/api/templates';
import mediasApi from '@/api/medias';

export default {
	name: 'RundownItem',
	props: {
		rundown: {
			type: Object,
		},
		rundownSlug: {
		},
		selectedItem: {
			type: Object,
		},
		scrollVisible: {
			type: Boolean,
		},
		closeContextItem: {
			type: Boolean,
		},
		isPlayingMacroListDone: {
			type: Boolean,
		},
		visibleElements: {
			type: Number,
		},
		keyword: {
			default: '',
		},
	},
	components: {
		EarthIcon,
		ImageIcon,
		AlphaAIcon,
		FormatSizeIcon,
		RadioTowerIcon,
		VideoIcon,
		ClockIcon,
		PictureInPictureIcon,
		TransitionIcon,
		PlayBoxIcon,
		MovieIcon,
		FormatTextRotationNoneIcon,
		ViewCompactIcon,
		WebcamIcon,
		CubeIcon,
		MusicIcon,
	},
	data() {
		return {
			isUpdating: false,
			isPlaying: false,
			hideTimer: ['image', 'video_input', 'custom_page', 'ticker', 'zoom_meeting', 'composition', 'lottie', 'virtual_cam'],
			playTime: localStorage.getItem(`item_duration_${this.rundown.id}`) ? localStorage.getItem(`item_duration_${this.rundown.id}`) : 0,
			playTimeInterval: null,
			opened: false,
			// composition error
			videoOptions: [],
			itemById: [],
			tempId: [],
			i: 0,
			timeOut: null,
			smallScreen: false,
			optionMobileOpened: false,
			isDelayPlay: false,
			isShowPlaying: false,
			showAccessItem: false,
			xContext: 0,
			showRenderItem: false,
			isRendering: 0,
			isFadeOutingPreview: false,
			isFadeOutingLive: false,
		};
	},
	sockets: {
		item_update(item) {
			if (item && item.play_time) {
				this.playTime = item.play_time;
			}
		},
		items_reorder(data) {
			const { items } = data;
			for (let index = 0; index < items.length; index++) {
				const item = items[index];
				if (this.rundown && item.id === this.rundown.id) {
					this.playTime = localStorage.getItem(`item_duration_${this.rundown.id}`) ? localStorage.getItem(`item_duration_${this.rundown.id}`) : 0;
				}
				if (this.rundown && item.id !== this.rundown.id && !this.rundown.is_play_live) {
					clearInterval(this.playTimeInterval);
					this.playTimeInterval = null;
				}
				if (this.rundown && item.id === this.rundown.id && this.rundown.is_play_live) {
					clearInterval(this.playTimeInterval);
					this.playTimeInterval = null;
					this.startProgress(item);
				}
			}
		},
		items_live_update(items) {
			const filteredStartItems = items.filter(item => item.is_play_live || ((item.is_play_live && item.is_update_live && item.type === 'lower_third')));
			const filteredStopItems = items.filter(item => !item.is_play_live || ((item.is_play_live && !item.is_update_live && item.type === 'lower_third')));
			const lastItem = items && items.length > 0 ? duplicateVar(items[items.length - 1]) : null;
			const ultimateParent = lastItem && lastItem.isUltimateParent ? lastItem : null;
			if (filteredStartItems > 1 && ultimateParent) filteredStartItems.pop();

			const sortedStartItems = filteredStartItems.sort((a, b) => {
				const parsedA = JSON.parse(a.content);
				const parsedB = JSON.parse(b.content);
				return (parsedA.childOrder < parsedB.childOrder) ? -1 : 1;
			});

			for (let index = 0; index < filteredStopItems.length; index++) {
				const item = filteredStopItems[index];
				if (item.id === this.rundown.id && !item.is_play_live) {
					this.stopProgress(item);
					const payload = {
						rundown_item_id: item.id,
						is_show_play: 0,
						rundown_slug: atob(this.rundownSlug),
					};
					this.$socket.client.emit('set_item_show_playing', payload);
					this.isShowPlaying = false;
				}
			}

			if (sortedStartItems.length > 0) {
				// setTimeout(() => {
				if (sortedStartItems[0].id === this.rundown.id && this.hasProgress) this.startProgress(sortedStartItems[0]);
				if (sortedStartItems[0] && sortedStartItems[0].id === this.rundown.id) {
					const payload = {
						rundown_item_id: sortedStartItems[0].id,
						is_show_play: 1,
						rundown_slug: atob(this.rundownSlug),
					};
					this.$socket.client.emit('set_item_show_playing', payload);
				}
				this.waitAndPlay(sortedStartItems, 0, lastItem);
				// }, 300);
			}
		},
		items_preview_update(items) {
			const filteredStopItems = items.filter(item => !item.is_play_preview || ((item.is_play_preview && !item.is_update_preview && item.type === 'lower_third')));
			for (let index = 0; index < filteredStopItems.length; index++) {
				const item = filteredStopItems[index];
				// disabled when fadeout audio
				const isAudio = item && item.type === 'audio' ? item.type === 'audio' : '';
				if (isAudio) {
					this.isFadeOutingPreview = true;
					setTimeout(() => {
						this.isFadeOutingPreview = false;
					}, 1100);
				} else {
					this.isFadeOutingPreview = false;
				}
			}
		},
		item_show_playing(rundownItem) {
			if (rundownItem.id === this.rundown.id) {
				// this.startProgress(this.rundown);
				//
			}
		},
		rundown_stop(items) {
			const index = items.findIndex(({ id }) => id === this.rundown.id);
			if (index !== -1) {
				const currentItem = items[index];
				if (!currentItem.is_play_live) {
					const payload = {
						rundown_item_id: currentItem.id,
						is_show_play: 0,
						rundown_slug: atob(this.rundownSlug),
					};
					this.$socket.client.emit('set_item_show_playing', payload);
					this.isShowPlaying = false;
					this.stopProgress(currentItem);
				}
			}
		},
	},
	directives: {
		ClickOutside,
	},
	methods: {
		waitAndPlay(items, i, lastItem) {
			const currentItem = items && items.length > i ? items[i] : null;
			const currentItemContent = currentItem ? JSON.parse(items[i].content) : null;
			const contentSortedStartItem = currentItemContent;
			const nextItem = items && i < items.length - 1 ? items[i + 1] : null;
			const ultimateParent = lastItem && lastItem.isUltimateParent ? lastItem : null;
			const ultimateParentContent = ultimateParent ? JSON.parse(ultimateParent.content) : null;
			const itemLength = items.length;
			const ultimateParentDuration = ultimateParentContent && ultimateParentContent.childOrder ? ultimateParentContent.childOrder : 0;
			const childDuration = contentSortedStartItem && contentSortedStartItem.childOrder ? contentSortedStartItem.childOrder : 0;
			let duration = childDuration < 0 ? ((childDuration * -1))
				: (childDuration);

			if (currentItem && currentItem.id === this.rundown.id && currentItem.is_play_live) {
				if (this.rundown.is_play_live) {
					const payload = {
						rundown_item_id: this.rundown.id,
						is_show_play: 1,
						rundown_slug: atob(this.rundownSlug),
					};

					this.$socket.client.emit('set_item_show_playing', payload);
					this.startProgress(currentItem);
				}
			}

			if (ultimateParent && currentItem && currentItem.id === ultimateParent.id) {
				if (nextItem) {
					const nextItemContent = nextItem && nextItem.content ? JSON.parse(nextItem.content) : '{}';
					const nextChildDuration = nextItemContent && nextItemContent.childOrder ? nextItemContent.childOrder : 0;
					if (nextChildDuration > ultimateParentDuration) {
						duration = nextChildDuration < 0 ? ((nextChildDuration * -1))
							: (nextChildDuration);
					}
				}
			}

			if (nextItem) {
				const nextItemContent = nextItem && nextItem.content ? JSON.parse(nextItem.content) : '{}';
				const nextChildDuration = nextItemContent && nextItemContent.childOrder ? nextItemContent.childOrder : 0;
				if (nextItem.id === this.rundown.id && nextItem.is_play_live) {
					if (nextChildDuration === childDuration) {
						// this.startProgress(nextItem);
						if (this.rundown.is_play_live) {
							duration = 0;
						}
					} else {
						// eslint-disable-next-line no-lonely-if
						if (childDuration > ultimateParentDuration) {
							// if (newItemUpdatedDate.isSame(currentItemUpdatedDate) || newItemUpdatedDate.isAfter(currentItemUpdatedDate)) this.startProgress(currentItem);
							duration = nextChildDuration < 0 ? (nextChildDuration * -1) : nextChildDuration;
						}
					}
				}
				// if (childDuration > ultimateParentDuration) {
				// 	// if (newItemUpdatedDate.isSame(currentItemUpdatedDate) || newItemUpdatedDate.isAfter(currentItemUpdatedDate)) this.startProgress(currentItem);
				// 	duration = nextChildDuration < 0 ? (nextChildDuration * -1) * 1000 : nextChildDuration * 1000;
				// }
			}
			const timeOut = setTimeout(() => { //  call a 3s setTimeout when the loop is called
				let indexInterval = i + 1;
				if (indexInterval < itemLength) { //  if the counter < 10, call the loop function
					this.waitAndPlay(items, indexInterval, lastItem); //  ..  again which will trigger another
				} //  ..  setTimeout()
				if (indexInterval === itemLength) {
					clearTimeout(timeOut);
					indexInterval = 0;
				}
			}, duration);
			// }
		},
		toggleContextMacro() {
			this.opened = true;
		},
		getPosContext() {
			const x = document.getElementById('contextItemRundown');
			this.xContext = x.getBoundingClientRect().top;
		},
		hideContextMacro() {
			this.opened = false;
		},
		initData() {
			if (this.rundown && this.rundown.play_time) {
				this.playTime = localStorage.getItem(`item_duration_${this.rundown.id}`) ? localStorage.getItem(`item_duration_${this.rundown.id}`) : this.rundown.play_time;
			}
		},
		update(params) {
			this.isUpdating = true;
			const id = this.rundown.id;
			const callback = (response) => {
				const rundown = response.data;
				this.$emit('update', rundown);
				this.isUpdating = false;
			};
			const errorCallback = () => {
				this.isUpdating = false;
			};
			rundownItemsApi.update(id, params, callback, errorCallback);
		},
		addCounter(dataById, key) {
			const callback = () => {
				if (key === 'media') {
					this.contentData.hasPlayed = true;
					this.hasPlayed();
				} else {
					this.contentData.template.hasPlayed = true;
					this.hasPlayed();
				}
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Template',
					text: message,
				});
			};
			if (key === 'media') {
				const dataParse = dataById && dataById.content ? JSON.parse(dataById.content) : null;
				const id = dataParse && dataParse.id ? dataParse.id : '';
				if ((this.contentData && this.contentData.id && !this.contentData.hasPlayed)) {
					mediasApi.selected(id, callback, errorCallback);
				}
			} else if (key === 'lower_third') {
				const dataParse = dataById && dataById.content ? JSON.parse(dataById.content) : null;
				const id = dataParse && dataParse.template && dataParse.template.id ? dataParse.template.id : '';
				if ((this.contentData && this.contentData.template && !this.contentData.template.hasPlayed)) {
					templatesApi.selected(id, callback, errorCallback);
				}
			}
		},
		renderFrame(status) {
			// const id = this.rundown.id;
			const callback = (response) => {
				this.opened = false;
				const data = response.data;
				const message = response.message;
				this.$notify({
					group: 'app',
					type: 'success',
					title: 'Template',
					text: message,
				});
				this.isRendering = data && data.is_lottie_rendering ? data.is_lottie_rendering : 0;
				this.showRenderItem = false;
				this.showAccessItem = false;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Template',
					text: message,
				});
			};
			const template = this.content && this.content.template ? this.content.template : null;
			if (template) {
				const url = template.file_path ? template.file_path : '';
				const params = {
					url,
					name: this.rundown.slug,
					id: this.rundown.id,
				};
				rundownItemsApi.renderFrame(status, params, callback, errorCallback);
				this.$notify({
					group: 'app',
					type: 'success',
					title: 'Generate Frame',
					text: 'Please wait while we try to generate frame',
				});
			}
		},
		forcePlay() {
			const id = this.rundown.id;
			const callback = () => {
				this.opened = false;
				this.playTime = 0;
			};
			const errorCallback = () => {
			};
			rundownItemsApi.forcePlay(id, callback, errorCallback);
		},
		delayPlay(status) {
			this.isDelayPlay = true;
			this.togglePlay(status);
		},
		togglePlay(status, forcePlay = false) {
			this.$emit('clickItem', true);
			// preview item
			const selectedId = this.selectedItem && this.selectedItem.id ? this.selectedItem.id : '';
			if (this.rundown.id !== selectedId) {
				this.$emit('setSelectedItem', this.rundown);
			}
			if (this.isLocked) return; // Disable when ed
			// Make request first then change local state
			let content = this.rundown.content;
			if (typeof content === 'string') {
				content = JSON.parse(content);
				if (content.url === '' && this.hasUrl) {
					this.isDelayPlay = false;
					return;
				}
			} else {
				return;
			}
			let item = this.rundown;
			const id = this.rundown.id;
			let userActivateAllItem = this.isAllItemSetting;

			if (status === 'preview') {
				const selectedId = this.selectedItem && this.selectedItem.id ? this.selectedItem.id : '';
				if (this.rundown.id !== selectedId) {
					this.$emit('previewClick', this.rundown);
				}
			} else {
				if (!this.isPlayingLive) {
					if ((item && item.type === 'image') || (item && item.type === 'video') || (item && item.type === 'lottie')) {
						this.addCounter(item, 'media');
						item = null;
					} else if (item && item.type === 'lower_third') {
						this.addCounter(item, 'lower_third');
						item = null;
					}
					const payload = {
						rundown_item_id: this.rundown.id,
						is_show_play: 1,
						rundown_slug: atob(this.rundownSlug),
					};
					this.$socket.client.emit('set_item_show_playing', payload);
				} else {
					// no for lower third

					// eslint-disable-next-line no-lonely-if
					if (this.rundown.type !== 'lower_third') {
						const payload = {
							rundown_item_id: this.rundown.id,
							is_show_play: 0,
							rundown_slug: atob(this.rundownSlug),
						};
						this.$socket.client.emit('set_item_show_playing', payload);
					}
				}
				userActivateAllItem = false;
			}
			const isComposition = this.content && this.content.composition;
			if (this.rundown.type === 'composition' && !isComposition) {
				this.$notify({
					group: 'app',
					type: 'warning',
					title: 'Device not found',
					duration: 4000,
					text: 'You have not select any composition',
				});
				return;
			}
			const callback = (response) => {
				this.isDelayPlay = false;
				const items = response.data;
				const item = items.find(({ id }) => id === this.rundown.id);
				// if composition has no deviceId
				if (item.type === 'composition') {
					const itemParse = JSON.parse(item.content);
					const responseDeviceId = itemParse && itemParse.composition && itemParse.composition.device_id ? itemParse.composition.device_id : null;
					const deviceIdComposition = this.videoOptions.find(({ deviceId }) => deviceId === responseDeviceId);
					if (!deviceIdComposition && item.is_play_preview === 1) {
						this.$notify({
							group: 'app',
							type: 'warning',
							title: 'Device not found',
							duration: 99999,
							text: 'Please open Composition Editor, if your video feed is not visible',
						});
					}
				}
				// disabled when fadeout audio
				const isStopPreview = item && !item.is_play_preview ? !item.is_play_preview : 0;
				const isStopLive = item && !item.is_play_live ? !item.is_play_live : 0;
				const isAudio = item && item.type === 'audio' ? item.type === 'audio' : '';
				if (status === 'preview' && isStopPreview && isAudio) {
					this.isFadeOutingPreview = true;
					setTimeout(() => {
						this.isFadeOutingPreview = false;
					}, 1100);
				} else {
					this.isFadeOutingPreview = false;
				}
				if (status === 'live' && isStopLive && isAudio) {
					this.isFadeOutingLive = true;
					setTimeout(() => {
						this.isFadeOutingLive = false;
					}, 1100);
				} else {
					this.isFadeOutingLive = false;
				}
				// toogle progress
				this.toggleProgress(item);
				this.$emit('update', items);
				this.isUpdating = false;
				if (item && !item.is_play_live && forcePlay) {
					setTimeout(() => {
						this.togglePlay('live');
					}, 500);
				} else if (item && item.type === 'lower_third' && item.is_play_live && !item.is_update_live && forcePlay) {
					setTimeout(() => {
						this.togglePlay('live', true);
					}, 500);
				}
			};
			const errorCallback = () => {
				this.isUpdating = false;
			};
			const params = {
				isAllItem: userActivateAllItem,
			};
			if (this.hasUrl) {
				if (this.content && this.content.url) {
					rundownItemsApi.togglePlay(id, status, params, callback, errorCallback);
				}
			} else {
				rundownItemsApi.togglePlay(id, status, params, callback, errorCallback);
			}
		},
		toggleProgress(item) {
			if (item && this.hasProgress) {
				if (item.is_play_live) {
					// this.startProgress(item);
				} else {
					this.stopProgress(item);
				}
			}
		},
		forceReset() {
			if (this.isLocked) return; // Disable when ed
			const id = this.rundown.id;
			const callback = () => {
				this.opened = false;
				// const items = response.data;
				// this.$emit('update', items);
				this.isUpdating = false;
			};
			const errorCallback = () => {
				this.isUpdating = false;
			};
			rundownItemsApi.forceReset(id, callback, errorCallback);
		},
		toggleHide(status) {
			if (this.isLocked) return; // Disable when ed
			const id = this.rundown.id;
			if (status === 'preview') {
				this.$emit('previewClick', this.rundown);
			}
			const callback = (response) => {
				this.opened = false;
				const items = response.data;
				this.$emit('update', items);
				this.isUpdating = false;
			};
			const errorCallback = () => {
				this.isUpdating = false;
			};
			rundownItemsApi.toggleHide(id, status, callback, errorCallback);
		},
		// forcePlay() {
		// 	if (this.isLocked) return; // Disable when ed
		// 	this.togglePlay('live');
		// },
		takeIn() {
			if (this.isLocked) return; // Disable when ed
			const id = this.rundown.id;
			const callback = (response) => {
				this.opened = false;
				const items = response.data;
				this.$emit('update', items);
				this.isUpdating = false;
			};
			const errorCallback = () => {
				this.isUpdating = false;
			};
			const params = {
				isAllItem: false,
			};
			rundownItemsApi.togglePlay(id, 'live', params, callback, errorCallback);
		},
		ActivePreview() {
			const status = this.selectedItem ? this.selectedItem.id === this.rundown.id : false;
			return status;
		},
		toggleShy() {
			this.opened = false;
			const isShy = !this.isShy;
			const isShyValue = isShy ? 1 : 0;
			const params = { is_shy: isShyValue };
			this.update(params);
		},
		toggleLock() {
			this.opened = false;
			const isLocked = !this.isLocked;
			const isLockedValue = isLocked ? 1 : 0;
			const params = { is_locked: isLockedValue };
			this.update(params);
			this.optionMobileOpened = false;
		},
		hasPlayed() {
			const params = { content: JSON.stringify(this.contentData) };
			this.update(params);
		},
		edit() {
			this.opened = false;
			this.optionMobileOpened = false;
			this.$emit('edit', this.rundown);
		},
		editLtMobile() {
			this.optionMobileOpened = false;
			this.$emit('editLtMobile', this.rundown);
		},
		duplicate() {
			this.opened = false;
			this.$emit('duplicate', this.rundown);
		},
		remove() {
			this.opened = false;
			this.optionMobileOpened = false;
			this.$emit('remove', this.rundown);
		},
		setSelected() {
			const selectedId = this.selectedItem && this.selectedItem.id ? this.selectedItem.id : '';
			if (this.rundown.id !== selectedId) {
				this.$emit('setSelectedItem', this.rundown);
			}
			if (this.smallScreen) {
				this.togglePlay('preview');
			}
		},
		startProgress(item) {
			if (!this.playTimeInterval) {
				let duration = '';
				// if item has in/out point
				if (this.type === 'video' || this.type === 'audio') {
					const content = this.rundown && this.rundown.content ? JSON.parse(this.rundown.content) : null;
					if (content.outPoint) {
						const inPoint = this.convertTimeToDecimal(content.inPoint);
						let outPoint = this.convertTimeToDecimal(content.outPoint);
						const originDuration = Math.floor(content.duration);
						if (outPoint === parseInt(originDuration)) outPoint = content.duration.toFixed(0);
						const durationResult = (outPoint - inPoint);
						duration = durationResult;
					}
				} else if (this.type !== 'video' && this.type !== 'audio') {
					duration = getDuration(item);
				}
				const isLoop = this.content.loop;
				this.playTimeInterval = setInterval(() => {
					if (this.playTime < duration) {
						this.playTime++;
						localStorage.setItem(`item_duration_${item.id}`, this.playTime);
						// disabled when fadeout audio
						if (duration - this.playTime === 1) {
							const isAudio = this.rundown && this.rundown.type === 'audio' ? this.rundown.type === 'audio' : '';
							if (isAudio) {
								this.isFadeOutingLive = true;
								setTimeout(() => {
									this.isFadeOutingLive = false;
								}, 2000);
							}
						}
					}

					// if (this.playTime > duration && this.rundown.type !== 'lower_third') {
					// 	this.playTime = 0;
					// 	localStorage.removeItem(`item_duration_${item.id}`);
					// }

					if (this.playTime > duration - 1) {
						if (isLoop) {
							this.playTime = 0;
							localStorage.setItem(`item_duration_${item.id}`, this.playTime);
						} else {
							const isResetPlaytime = false;
							this.stopProgress(item, isResetPlaytime);
							localStorage.removeItem(`item_duration_${item.id}`);
						}
					}
				}, 1000);
			}
		},
		stopProgress(item, isResetPlaytime = true) {
			if (this.playTimeInterval) clearInterval(this.playTimeInterval);
			if (isResetPlaytime) {
				this.playTime = 0;
			} else {
				// if type is video
				// eslint-disable-next-line no-lonely-if
				if (this.type === 'video' || this.type === 'audio') {
					const content = this.rundown && this.rundown.content ? JSON.parse(this.rundown.content) : null;
					if (content.outPoint) {
						const inPoint = this.convertTimeToDecimal(content.inPoint);
						const outPoint = this.convertTimeToDecimal(content.outPoint);
						const duration = (outPoint - inPoint);
						this.playTime = duration;
					}
				}
			}
			localStorage.removeItem(`item_duration_${item.id}`);
			this.playTimeInterval = null;
		},
		onClick(e) {
			const el = this.$refs.dropdownContextRundown;
			const target = e.target;
			if ((el !== target) && !el.contains(target)) {
				this.opened = false;
			}
		},
		initDevices() {
			RTC.load(() => {
				RTC.MediaDevices.map((device) => {
					if (device.kind === 'videoinput') {
						this.videoOptions.push(device);
						this.programOptions.push(device);
					}
					return device;
				});
			});
		},
		// method for checking user click list rundown editor or asset property
		clickItem() {
			this.$emit('clickItem', true);
		},
		stringToSeconds(sec) {
			const hms = sec; // your input string
			const a = hms.split(':'); // split it at the colons
			// minutes are worth 60 seconds. Hours are worth 60 minutes.
			const seconds = (+a[0]) * 60 + (+a[1]);
			return seconds;
		},
		stringToSecondsTimer(sec) {
			const hms = sec; // your input string
			const a = hms.split(':'); // split it at the colons
			// minutes are worth 60 seconds. Hours are worth 60 minutes.
			const seconds = (+a[0]) * 60 * 60 + (+a[1]) * 60 + (+a[2]);
			return seconds;
		},
		onResizeWidth() {
			if (window.innerWidth <= 1024) {
				this.smallScreen = true;
			} else {
				this.smallScreen = false;
			}
		},
		toggleContextOptionMobile() {
			this.optionMobileOpened = !this.optionMobileOpened;
		},
		hideContextOptionMobile() {
			this.optionMobileOpened = false;
		},
		toggleMute() {
			this.optionMobileOpened = false;
			if (this.type === 'video_input') {
				const isMuted = !this.isMuted;
				this.contentData.isMuted = isMuted;
				const params = { content: JSON.stringify(this.contentData) };
				this.update(params);
			} else {
				const isMuted = !this.isMutedMedia;
				this.contentData.muted = isMuted;
				const params = { content: JSON.stringify(this.contentData) };
				this.update(params);
			}
		},
		convertTimeToDecimal(time) {
			const hms = time;// your input string
			const a = hms.split(':'); // split it at the colons
			const seconds = (+a[0]) * 60 * 60 + (+a[1]) * 60 + (+a[2]);
			return seconds;
		},
		convertDecimalToTime(duration) {
			const hours = (duration / 3600 >= 1) ? parseInt(duration / 3600) : 0;
			const minutes = parseInt(parseInt(duration % 3600) / 60);
			const seconds = parseInt(duration % 60);
			const hoursLabel = hours < 10 ? `0${hours}` : hours;
			const minutesLabel = minutes < 10 ? `0${minutes}` : minutes;
			const secondsLabel = seconds < 10 ? `0${seconds}` : seconds;
			const durationLabel = hours > 0 ? `${hoursLabel}:${minutesLabel}:${secondsLabel}` : `${minutesLabel}:${secondsLabel}`;
			return durationLabel;
		},
		copyURLitem(status) {
			if (status === 'play') {
				const callback = (response) => {
					const url = response.url;
					const message = response.message;
					copyToClipboard(url);
					this.$notify({
						group: 'app',
						type: 'success',
						title: 'Item URL',
						text: message,
					});
					this.opened = false;
				};
				const errorCallback = (e) => {
					const message = getAxiosErrorMessage(e);
					this.$notify({
						group: 'app',
						type: 'error',
						title: 'Item URL',
						text: message,
					});
					this.opened = false;
				};
				rundownItemsApi.accessItemLink(this.rundown.id, status, callback, errorCallback);
			}
			if (status === 'stop') {
				const callback = (response) => {
					const url = response.url;
					copyToClipboard(url);
					const message = response.message;
					this.$notify({
						group: 'app',
						type: 'success',
						title: 'Item URL',
						text: message,
					});
					this.opened = false;
				};
				const errorCallback = (e) => {
					const message = getAxiosErrorMessage(e);
					this.$notify({
						group: 'app',
						type: 'error',
						title: 'Item URL',
						text: message,
					});
					this.opened = false;
				};
				rundownItemsApi.accessItemLink(this.rundown.id, status, callback, errorCallback);
			}
			if (status === 'pause') {
				const callback = (response) => {
					const url = response.url;
					copyToClipboard(url);
					const message = response.message;
					this.$notify({
						group: 'app',
						type: 'success',
						title: 'Item URL',
						text: message,
					});
					this.opened = false;
				};
				const errorCallback = (e) => {
					const message = getAxiosErrorMessage(e);
					this.$notify({
						group: 'app',
						type: 'error',
						title: 'Item URL',
						text: message,
					});
					this.opened = false;
				};
				rundownItemsApi.accessItemLink(this.rundown.id, status, callback, errorCallback);
			}
			if (status === 'resume') {
				const callback = (response) => {
					const url = response.url;
					copyToClipboard(url);
					const message = response.message;
					this.$notify({
						group: 'app',
						type: 'success',
						title: 'Item URL',
						text: message,
					});
					this.opened = false;
				};
				const errorCallback = (e) => {
					const message = getAxiosErrorMessage(e);
					this.$notify({
						group: 'app',
						type: 'error',
						title: 'Item URL',
						text: message,
					});
					this.opened = false;
				};
				rundownItemsApi.accessItemLink(this.rundown.id, status, callback, errorCallback);
			}
			this.opened = false;
		},
		openContextRender() {
			this.showRenderItem = true;
			this.showAccessItem = false;
		},
		openContextAccess() {
			this.showAccessItem = true;
			this.showRenderItem = false;
		},
		closeContext() {
			this.showRenderItem = false;
			this.showAccessItem = false;
		},
	},
	beforeDestroy() {
		clearInterval(this.playTimeInterval);
	},
	computed: {
		...mapGetters({
			user: 'user',
		}),
		isAllItemSetting() {
			const settings = this.user && this.user.settings ? JSON.parse(this.user.settings) : null;
			const isAllItem = settings && settings.is_enable_all_preview ? settings.is_enable_all_preview : false;
			return isAllItem;
		},
		userRenderSequences() {
			const settings = this.user && this.user.settings ? JSON.parse(this.user.settings) : null;
			const userSubscription = settings && settings.subscription ? settings.subscription : null;
			const renderSequencesSetting = userSubscription && userSubscription.render_sequence ? userSubscription.render_sequence : null;
			const isRenderSequencesEnable = renderSequencesSetting && renderSequencesSetting.is_enabled ? renderSequencesSetting.is_enabled : false;
			return isRenderSequencesEnable;
		},
		elementId() {
			return 'dropdownContextRundown';
		},
		type() {
			return this.rundown ? this.rundown.type : null;
		},
		icon() {
			const icon = getRundownItemIcon(this.type);
			return `${icon}-icon`;
		},
		isSeparator() {
			return !!(this.rundown && this.rundown.type === 'separator');
		},
		isPlayingLive() {
			return this.rundown && this.rundown.is_play_live === 1;
		},
		isPlayingPreview() {
			return this.rundown && this.rundown.is_play_preview === 1;
		},
		isMuted() {
			const parse = this.rundown && this.rundown.content ? JSON.parse(this.rundown.content) : null;
			return parse && parse.isMuted ? parse.isMuted : '';
		},
		isMutedMedia() {
			const parse = this.rundown && this.rundown.content ? JSON.parse(this.rundown.content) : null;
			return parse && parse.muted ? parse.muted : '';
		},
		contentData() {
			const parse = this.rundown && this.rundown.content ? JSON.parse(this.rundown.content) : null;
			return parse && parse;
		},
		isShy() {
			return this.rundown && this.rundown.is_shy === 1;
		},
		isLocked() {
			return this.rundown && this.rundown.is_locked === 1;
		},
		isDisabled() {
			return this.rundown && this.rundown.is_disabled === 1;
		},
		hasUrl() {
			const availableTypes = [
				'lottie',
				'image',
				'video',
				'audio',
			];

			const isHasUrl = availableTypes.includes(this.type);
			return isHasUrl;
		},
		hasProgress() {
			const availableTypes = [
				'lower_third',
				'ticker',
				'timer',
				'video',
				'audio',
			];

			const isHasProgress = availableTypes.includes(this.type);
			return isHasProgress;
		},
		progress() {
			let durationResult = this.rundown;
			// if item has in/out point
			if (this.type === 'video' || this.type === 'audio') {
				const content = this.rundown && this.rundown.content ? JSON.parse(this.rundown.content) : null;
				if (content.outPoint) {
					const inPoint = this.convertTimeToDecimal(content.inPoint);
					const outPoint = this.convertTimeToDecimal(content.outPoint);
					const duration = (outPoint - inPoint);
					durationResult = duration;
				}
			} else if (this.type !== 'video' && this.type !== 'audio') {
				durationResult = getDuration(this.rundown);
			}
			let progress = (this.playTime / durationResult) * 100;
			if (progress < 0) progress = 0;
			return `${progress}%`;
		},
		duration() {
			const parse = this.rundown && this.rundown.content ? JSON.parse(this.rundown.content) : null;
			return parse && parse.duration ? parse.duration : '';
		},
		LowerThirdDuration() {
			const content = this.rundown && this.rundown.content ? JSON.parse(this.rundown.content) : null;
			let duration = 0;
			if (this.isPlayingLive) {
				duration = content && content.duration ? this.stringToSeconds(content.duration) - this.playTime : this.stringToSeconds('00:00');
			} else {
				duration = content && content.duration ? this.stringToSeconds(content.duration) : this.stringToSeconds('00:00');
			}
			const minutes = parseInt(parseInt(duration % 3600) / 60);
			const seconds = parseInt(duration % 60);
			const minutesLabel = minutes < 10 ? `0${minutes}` : minutes;
			const secondsLabel = seconds < 10 ? `0${seconds}` : seconds;

			const durationLabel = `${minutesLabel}:${secondsLabel}`;
			return durationLabel;
		},
		timerDuration() {
			const content = this.rundown && this.rundown.content ? JSON.parse(this.rundown.content) : null;
			let duration = 0;
			if (this.isPlayingLive) {
				duration = content && content.time ? this.stringToSecondsTimer(content.time) - this.playTime : this.stringToSecondsTimer('00:00:00');
			} else {
				duration = content && content.time ? this.stringToSecondsTimer(content.time) : this.stringToSecondsTimer('00:00:00');
			}
			if (content.time.length > 5) {
				if (duration <= 0) duration = content && content.time ? this.stringToSecondsTimer('00:00:00') : this.stringToSecondsTimer('00:00:00');
				const hours = (duration / 3600 >= 1) ? parseInt(duration / 3600) : 0;
				const minutes = parseInt(parseInt(duration % 3600) / 60);
				const seconds = parseInt(duration % 60);
				const hoursLabel = hours < 10 ? `0${hours}` : hours;
				const minutesLabel = minutes < 10 ? `0${minutes}` : minutes;
				const secondsLabel = seconds < 10 ? `0${seconds}` : seconds;

				const durationLabel = hours > 0 ? `${hoursLabel}:${minutesLabel}:${secondsLabel}` : `${minutesLabel}:${secondsLabel}`;
				return durationLabel;
				// eslint-disable-next-line
			} else {
				return '00:00:00';
			}
		},
		mediaDuration() {
			const content = this.rundown && this.rundown.content ? JSON.parse(this.rundown.content) : null;
			let duration = 0;
			if (this.isPlayingLive) {
				duration = content && content.duration ? content.duration - this.playTime : 0;
			} else {
				duration = content && content.duration ? content.duration : 0;
			}
			duration = this.convertDecimalToTime(duration);
			// if item is video and has in/out point
			if (this.type === 'video' || this.type === 'audio') {
				if (content && content.outPoint) {
					const inPoint = this.convertTimeToDecimal(content.inPoint);
					const outPoint = this.convertTimeToDecimal(content.outPoint);
					duration = (outPoint - inPoint);
					if (this.isPlayingLive) {
						if (duration >= 0) {
							duration = duration ? duration - this.playTime : 0;
						} else {
							duration = 0;
						}
					} else {
						duration = duration || 0;
					}
					// return duration after format
					duration = this.convertDecimalToTime(duration.toFixed(0));
					return duration;
				}
			}
			return duration;
		},
		time() {
			const parse = this.rundown && this.rundown.content ? JSON.parse(this.rundown.content) : null;
			return parse && parse.time ? parse.time : '';
		},
		content() {
			const parsedContent = this.rundown && this.rundown.content ? JSON.parse(this.rundown.content) : null;
			return parsedContent;
		},
		iconLabel() {
			return toTitleCase(this.rundown.type);
		},
		userCollaborators() {
			const currentRoleCollaborator = '';
			if (this.rundown && this.rundown.rundown_id) {
				const data = this.user && this.user.collaborators ? this.user.collaborators : '';
				// eslint-disable-next-line
				const current = data.find(({ rundown_ids }) => rundown_ids.includes(this.rundown && this.rundown.rundown_id));
				if (!current) return '';
				const currentRoleCollaborator = current && current.role ? current.role : '';
				return currentRoleCollaborator;
			}
			return currentRoleCollaborator;
		},
		urlItemRundown() {
			const baseUrl = process.env.VUE_APP_URL;
			const url = `${baseUrl}/rundowns/items/${this.rundown.id}`;
			return url;
		},
	},
	created() {
		this.initData();
		window.addEventListener('contextmenu', this.onClick);
		window.addEventListener('resize', this.onResizeWidth);
		this.onResizeWidth();
		this.isRendering = this.rundown && this.rundown.is_lottie_rendering ? this.rundown.is_lottie_rendering : 0;
	},
	mounted() {
		this.initDevices();
		if (this.isPlayingLive) {
			this.toggleProgress(this.rundown);
		}
		window.addEventListener('resize', this.onResizeWidth);
		this.onResizeWidth();
		this.popupItem = this.$el;
		if (this.rundown && this.rundown.is_play_live) { this.startProgress(this.rundown); }
	},
	destroyed() {
		window.removeEventListener('contextmenu', this.onClick);
	},
	watch: {
		rundown() {
			this.initData();
			this.isRendering = this.rundown && this.rundown.is_lottie_rendering ? this.rundown.is_lottie_rendering : 0;
		},
		keyword() {
			clearInterval(this.playTimeInterval);
			if (this.rundown && this.rundown.is_play_live) {
				this.playTime = localStorage.getItem(`item_duration_${this.rundown.id}`) ? localStorage.getItem(`item_duration_${this.rundown.id}`) : this.rundown.play_time;
				this.playTimeInterval = null;
				this.startProgress(this.rundown);
			}
		},
		showAccessItem() {
			if (this.showAccessItem) {
				this.getPosContext();
			}
		},
		opened() {
			if (!this.opened) {
				this.showAccessItem = false;
				this.showRenderItem = false;
			}
		},
		showRenderItem() {
			if (this.showRenderItem) {
				this.update();
			}
		},
	},
};
</script>

<style  lang="scss">
.rundown-name {
	cursor: pointer;
}
@import '~vue-context/dist/css/vue-context.css';
</style>
